import React from 'react';
import { createSvgIcon } from '../../icon';
/* eslint-disable max-len */
export default createSvgIcon('clear-1', '0 0 20 20', React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M15.833 5.342l-1.175-1.175L10 8.825 5.342 4.167 4.167 5.342 8.825 10l-4.658 4.658 1.175 1.175L10 11.175l4.658 4.658 1.175-1.175L11.175 10l4.658-4.658z" })));
